import { Route, Routes } from "react-router-dom";

import Tickets from "works/omagun/pages/Tickets";
import MyPage from "works/omagun/pages/MyPage";
import Quests from "works/omagun/pages/Quests";
import Trials from "works/omagun/pages/Trials";
import Missions from "works/omagun/pages/Missions";
import HowToUse from "works/omagun/pages/HowToUse";
import News from "works/omagun/pages/News";
import OmagunLayout from "works/omagun/components/OmagunLayout";
import PayPayCheck from "default/pages/PayPayCheck";
import PayPayPolling from "default/pages/PayPayPolling";

export default function OmagunRoutes() {
  return (
    <Routes>
      <Route path="/tickets" element={<Tickets />} />
      <Route path="/mypage" element={<MyPage />} />
      <Route path="/quests" element={<Quests />} />
      <Route path="/trials" element={<Trials />} />
      <Route path="/missions" element={<Missions />} />
      <Route path="/how-to-use" element={<HowToUse />} />
      <Route path="/news" element={<News />} />
      <Route path="/paypay/check" element={<PayPayCheck LayoutComponent={OmagunLayout} />} />
      <Route path="/check-paypay" element={<PayPayCheck LayoutComponent={OmagunLayout} />} />
      <Route path="/paypay/polling" element={<PayPayPolling LayoutComponent={OmagunLayout} />} />
      <Route path="/paypay-polling" element={<PayPayPolling LayoutComponent={OmagunLayout} />} />
    </Routes>
  );
}
